



















import { Component, Vue } from 'vue-property-decorator'
import { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import requests from '@/helpers/requests'


enum State {
    LOADING = 'loading',
    READY = 'ready',
    ERROR = 'error'
}


interface LeaderboardEntry {
    username: string;
    total: number;
    success: number;
    error: number;
    successRate: number;
    ErrorRate: number;
}


interface ResponseData extends DefaultServerResponse {
    data: {
        leaderboard: LeaderboardEntry[];
    };
}


@Component
export default class InternalToolsLeaderboard extends Vue {
    State = State
    currentState = State.LOADING
    errorMessage: null|string = null
    leaderboard: LeaderboardEntry[] = []
    tableHeaders = [
        {
            text: 'User',
            value: 'username',
            sortable: false
        },
        {
            text: 'Count',
            value: 'total',
            align: 'end'
        },
        {
            text: 'Success Rate',
            value: 'successRate',
            align: 'end'
        },
        {
            text: 'Error Rate',
            value: 'errorRate',
            align: 'end'
        }
    ]

    async mounted() {
        await this.load()
    }

    async load() {
        this.currentState = State.LOADING
        try {
            const response = await requests.post('/support/nerd/load-tech-task-leaderboard') as ResponseData
            this.leaderboard = response.data.leaderboard
            this.currentState = State.READY
        } catch(e) {
            this.currentState = State.ERROR
            this.errorMessage = e.message
        }
    }
}
